import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";

export default {
  namespaced: true,
  state: {
    profitsandloss: [],
    expenses: [],
    sales: [],
    total: null,
  },
  mutations: {
    SET_PROFITSANDLOSS(state, data) {
      state.profitsandloss = data;
    },
    SET_EXPENSES(state, data) {
      state.expenses = data;
    },
    SET_SALES(state, data) {
      state.sales = data;
    },
    SET_TOTALPAGES(state, data) {
      state.total = data;
    },
  },
  actions: {
    async getProfitandLoss({ commit }, params) {
      const headers = apiConfig().headers;
      const result = await API.get(`${ROUTES().report}/profit-and-loss`, {
        params,
        headers,
      })
        .then((res) => {
          commit("SET_PROFITSANDLOSS", res.data.data);
          // commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async getExpenses({ commit }, params) {
      const headers = apiConfig().headers;
      const result = await API.get(`${ROUTES().report}/expenses`, {
        params,
        headers,
      })
        .then((res) => {
          commit("SET_EXPENSES", res.data.data);
          // commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async getSales({ commit }, params) {
      const headers = apiConfig().headers;
      const result = API.get(`${ROUTES().report}/sales`, { params, headers })
        .then((res) => {
          commit("SET_SALES", res.data.data);
          // commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
  },
  getters: {
    profitsandloss(state) {
      return state.profitsandloss;
    },
    expenses(state) {
      return state.expenses;
    },
    sales(state) {
      return state.sales;
    },
  },
};
